module.exports = __webpack_public_path__ + "static/img/ent-detail-14.f9709c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-14.jpg
// module id = I25B
// module chunks = 52